import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ErrorException from "src/components/ErrorException";
import { ApiGatewayUrl } from "../../src/appsettings";
import Rest from "../../src/core/rest";

export const getUserProfile = createAsyncThunk(
    "setting/getUserProfile",
    async () => {
        try {
            const response = await Rest.get(ApiGatewayUrl + "/settings");
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
)

export const settingSlice = createSlice({
    name: "setting",
    initialState: {
    }

});
export const settingAction = settingSlice.actions;
export const settingState = (state) => state.setting;
export default settingSlice.reducer;